import React from 'react';

export interface MaterialIconProps {
  /** The Material Symbols glyph name (e.g. `"undo"`, `"rocket_launch"`). */
  name: string;
  /** When true, marks the glyph as decorative (default). */
  decorative?: boolean;
}

/**
 * Tiny wrapper around the Material Symbols Rounded font glyph the
 * floating canvas toolbars use. The handoff is built around
 * `material-symbols-rounded` (see `index.html` line 6 of the prototype),
 * so we render the glyph via the same class — `IconButton.styled.ts`
 * already special-cases `& > .material-symbols-rounded` and sizes it to
 * the IconButton's icon-size token.
 *
 * Kept colocated with the canvas toolbar because that's the only
 * consumer of the Rounded variant today. If/when more pages start
 * using Rounded glyphs, lift this into a shared `@aibuild/ui` atom.
 */
const MaterialIcon: React.FC<MaterialIconProps> = ({
  name,
  decorative = true,
}) => (
  <span
    className="material-symbols-rounded"
    aria-hidden={decorative ? 'true' : undefined}
  >
    {name}
  </span>
);

export default MaterialIcon;
